import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { CMSPath } from "../../../config/constant";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { sendAnalytics } from "../../../action/homeAction";


const ResReservationV2_1 = (props) => {

    const { t } = props

    const handleNext = () => {
        props.next()
    }

    return (
        <>

            <div class="widget-header">

                {props.currentWidgetObj.widgetHeaderImageUrl &&
                    <div class="widget-header-img">
                        <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                    </div>
                }

                <div class="widget-header-title">{props.selectedVenueData.name}</div>
            </div>

            <div class="widgets">
                <div class="row margin-bottom-2">
                    <div className="row">
                        <div className="col">
                            <div className="detail-body stay-body">
                                <form>
                                    {props.selectedVenueData.phone_number && 
                                        <div class="stay-info">
                                            <div class="stay-departure">
                                                <div class="heading">{t('resReservationV2.phone')}</div>
                                                <div class="body">
                                                    <p>{props.selectedVenueData.phone_number}</p>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {props.selectedVenueData.address && 
                                        <div class="stay-info">
                                            <div class="stay-location">
                                                <p class="heading">{t('resReservationV2.location')}</p>
                                                <p>{props.selectedVenueData.address}</p>
                                            </div>
                                        </div>
                                    }
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="form-controls">
                    <button onClick={() => handleNext()} class="primary">{t('resReservationV2.reserve_table')}</button>
                </div>
            </div>
        </>
    )

}

const mapStateToProps = state => {
    return {
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
    }
}

export default connect(mapStateToProps, { sendAnalytics })(withTranslation('translations')(ResReservationV2_1));